import { Component, Input, OnInit } from '@angular/core';
import { BetService } from '../../services/bet.service';
import { AuthService } from 'src/app/modules/auth/shared/auth.service';

@Component({
  selector: 'app-bet-print',
  templateUrl: './bet-print.component.html',
  styleUrls: ['./bet-print.component.scss']
})
export class BetPrintComponent implements OnInit {
  @Input() data: any; // printContent
  @Input() isBettingSlipModal: boolean;

  datas = []
  betTime: any;

  constructor(
    public betService: BetService,
    public authService: AuthService,
  ) {

  }

  ngOnInit(): void {
    if (this.isBettingSlipModal) {
      this.datas = [this.data]
    } else {
      this.betTime = this.data[this.data.length - 1].betTime
      this.datas = this.data.slice(0, this.data.length)

      this.datas.forEach((data) => {
        data.betSlip.bets.sort((a, b) => {
          return a.runnerOrder - b.runnerOrder;
        });
      }
      )
    }

  }

  getRunnerofBetData(data, order) {
    return data.betSlip.bets.filter((r) => r.runnerOrder === order);
  }
}
